import $ from 'jquery';
import JQueryView, { on } from '@/common/views/jqueryView';

export default class IndexView extends JQueryView {
  constructor() {
    super('.index');
    this.call_ajax('', '', '');
  }

  @on({ event: 'click', selector: 'td.link-cell' })
  onClickLinkCell(event: JQuery.ClickEvent) {
    const id = event.currentTarget.dataset.communityId;
    window.location.href = `/shareholder_communities/${id}`;
  }

  @on({ event: 'change', selector: '#select_status' })
  onChangeSelectStatus() {
    const selectStatus = $('#select_status').val()?.toString();
    if (selectStatus != null) {
      this.call_ajax(selectStatus, '', '');
    }
  }

  call_ajax(select_status: string, sort_column: string, sort_order: string) {
    const url = $('#community_list_shareholder_community_path')
      .val()
      ?.toString();
    if (url != null && url.length > 0) {
      $.ajax({
        type: 'GET',
        url: url,
        data: {
          select_status: select_status,
          sort_column: sort_column,
          sort_order: sort_order,
        },
      });
    }
  }
}
